














import { Component, Vue, Prop } from 'vue-property-decorator';
import MentorIcon from '@/components/parts/MentorIcon.vue';
import MentorInfo from '@/components/MentorInfo.vue';
import { Mentor } from '@/models/mentor';
import { getCardColor } from '@/main';

@Component({
  components: {
    MentorIcon,
    MentorInfo
  }
})
export default class MentorInfoUi extends Vue {
  @Prop()
  mentor?: Mentor | null;

  get getMentor() {
    return this.mentor;
  }
  getColor() {
    return getCardColor(this.mentor?.color);
  }

  mounted() {
    window.onresize = this.resize;
    this.resize();
  }

  resize() {
    const icon = (this.$refs.icon as Vue).$el as HTMLDivElement;
    const modal = this.$refs.modal as HTMLDivElement;
    let top = -1000;
    const iwidth = icon.offsetWidth;
    top = top > iwidth / -2 ? top : iwidth / -2;
    icon.style.top = `${top}px`;
    modal.style.top = `${iwidth / 2}px`;
  }
}
